import { ControlsToggleExtraContent, LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

export const component: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/05/11/principle/strong-early-normal-reverb.svg`,
        },
      },
    },
  },
];

export const extraContent: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      text: "Play sound",
      shape: "round",
      theme: "secondary",
      icon: "cis-volume-high",
      url: `${config.ASSETS_URL}/05/11/principle/strong-early-normal-reverb.wav`,
      styles: {
        paddingTop: "1.5em",
      },
    },
  },
];
